var observers={};

var zoomEl=function(el) {
  if (!el) return;
  var innerEl=$(el).find(">div")[0];
  var outerWidth=0;
  var innerWidth=0;
  var innerHeight=0;
  var obs=new ResizeObserver((event)=>{
    for(var evt of event) {
      if (evt.target==el) { // outer element
        outerWidth=evt.contentRect.width;
      } else if (evt.target==innerEl) {
        innerWidth=evt.contentRect.width;
        innerHeight=evt.contentRect.height;
      }
    }
    if (outerWidth && innerWidth) {
      var scale=outerWidth/innerWidth;
      innerEl.style.transform="scale("+scale+")";
      innerEl.style.transformOrigin="100% 100%";
      innerEl.style.marginLeft=innerWidth*(scale-1)+"px";
      innerEl.style.marginTop=innerHeight*(scale-1)+"px";
    }
  }, {});
  obs.observe(el);
  obs.observe(innerEl);
}

export default function() {
  $(".main-menu .wrapper, .zoom-wrapper").each(function() {
    zoomEl(this);
  });
  $(window).on("resize.viewport", function() {
    var vh = window.innerHeight;
    var ratio = window.innerWidth/window.innerHeight;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    document.documentElement.style.setProperty('--vratio', ratio);
  }).trigger("resize.viewport");
}
